import React, { useContext, useEffect, useState } from "react";
import "./curriculum.scss";
import Slider from "./Slider";
import { CSSTransition } from 'react-transition-group';
import { useLocation } from "react-router-dom";

//CONTEXT
import CurriculumContext from "../../../contexts/pages/curriculum/curriculumContext";

import Links from "./Links";
import AcademicArea from "./Subpages/AcademicArea/AcademicArea";
import EducativeModel from "./Subpages/EducativeModel";
import GraduateProfile from "./Subpages/GraduateProfile";
import InterdisciplinaryActivities from "./Subpages/InterdisciplinaryActivities";

const CurriculumPage = () => {
  const location = useLocation();
  const curriculumContext = useContext(CurriculumContext);
  const { subjects, getCurriculum, dotsLoaded,  
        studentProfileState,
        setStudentProfileState,
        academicAreasState,
        setAcademicAreasState,
        alliesState,
        setAlliesState,
        toolsState,
        setToolsState,
        cocurricularState,
        setCocurricularState,
        blankState,
        setBlankState } = curriculumContext;

  const [linkState, setLinkState]  = useState({
          studentProfileLinkState:false,
          academicAreasLinkState:false,
          alliesLinkState:false,
          toolsLinkState:false,
          cocurricularLinkState:false,
      })
  
    const handleCurrentLinkState = (newLinkState) => {
        setLinkState({
            ...newLinkState
        })
    }

    const animationStates = {
        studentProfileState,
        setStudentProfileState,
        academicAreasState,
        setAcademicAreasState,
        alliesState,
        setAlliesState,
        toolsState,
        setToolsState,
        cocurricularState,
        setCocurricularState,
        blankState,
        setBlankState
    }

  useEffect(() => {
    getCurriculum();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const seccion = params.get('seccion') || location.hash.replace('#', '');

    if (seccion === 'actividades-interdisciplinarias' || seccion === 'explora' || seccion === 'idiomas') {
      handleCurrentLinkState({
        studentProfileLinkState: false,
        academicAreasLinkState: false,
        alliesLinkState: false,
        toolsLinkState: false,
        cocurricularLinkState: true,
      });
      setStudentProfileState({ enter: false, active: false });
      setAcademicAreasState({ enter: false, active: false });
      setAlliesState({ enter: false, active: false });
      setToolsState({ enter: false, active: false });
      setCocurricularState({ enter: true, active: true });

      setTimeout(() => {
        const el = document.querySelector(".curriculum");
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 350);
    } else if (seccion === 'modelo-educativo') {
      handleCurrentLinkState({
        studentProfileLinkState: false,
        academicAreasLinkState: false,
        alliesLinkState: false,
        toolsLinkState: true,
        cocurricularLinkState: false,
      });
      setStudentProfileState({ enter: false, active: false });
      setAcademicAreasState({ enter: false, active: false });
      setAlliesState({ enter: false, active: false });
      setToolsState({ enter: true, active: true });
      setCocurricularState({ enter: false, active: false });

      setTimeout(() => {
        const el = document.querySelector(".curriculum");
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 350);
    } else if (seccion === 'perfil-egresado') {
      handleCurrentLinkState({
        studentProfileLinkState: true,
        academicAreasLinkState: false,
        alliesLinkState: false,
        toolsLinkState: false,
        cocurricularLinkState: false,
      });
      setStudentProfileState({ enter: true, active: true });
      setAcademicAreasState({ enter: false, active: false });
      setAlliesState({ enter: false, active: false });
      setToolsState({ enter: false, active: false });
      setCocurricularState({ enter: false, active: false });

      setTimeout(() => {
        const el = document.querySelector(".curriculum");
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 350);
    } else if (seccion === 'areas-academicas') {
      handleCurrentLinkState({
        studentProfileLinkState: false,
        academicAreasLinkState: true,
        alliesLinkState: false,
        toolsLinkState: false,
        cocurricularLinkState: false,
      });
      setStudentProfileState({ enter: false, active: false });
      setAcademicAreasState({ enter: true, active: true });
      setAlliesState({ enter: false, active: false });
      setToolsState({ enter: false, active: false });
      setCocurricularState({ enter: false, active: false });

      setTimeout(() => {
        const el = document.querySelector(".curriculum");
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 350);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, location.hash]);

  useEffect(() => {}, [dotsLoaded]);


  return (
    <div className="row curriculum-body">
      <Slider ClassName={"curriculum-slider"} />
      <div className="curriculum">
        
         <div className="row curriculum-inner" >
            <CSSTransition
                in={studentProfileState.active}
                timeout={500}
                classNames="feriaCultural-subarea"
                unmountOnExit
                onEnter={() => {
                    setAcademicAreasState({ enter: false, active: false });
                    setAlliesState({ enter: false, active: false });
                    setToolsState({enter: false, active: false});
                    setCocurricularState({enter: false, active: false});
                }}
                onExited={() => {
                  if (academicAreasState.enter) setAcademicAreasState({ ...academicAreasState, active: true });
                  if (alliesState.enter) setAlliesState({ ...alliesState, active: true });
                  if (toolsState.enter) setToolsState({ ...toolsState, active: true });
                  if (cocurricularState.enter) setCocurricularState({ ...cocurricularState, active: true });
                }}
            >
                <GraduateProfile />
            </CSSTransition>

            <CSSTransition
                in={academicAreasState.active}
                timeout={500}
                classNames="feriaCultural-subarea"
                unmountOnExit
                onEnter={() => {
                    setStudentProfileState({ enter: false, active: false });
                    setAlliesState({ enter: false, active: false });
                    setToolsState({enter: false, active: false});
                    setCocurricularState({enter: false, active: false});
                }}
                onExited={() => {
                  if (studentProfileState.enter) setStudentProfileState({ ...studentProfileState, active: true });
                  if (alliesState.enter) setAlliesState({ ...alliesState, active: true });
                  if (toolsState.enter) setToolsState({ ...toolsState, active: true });
                  if (cocurricularState.enter) setCocurricularState({ ...cocurricularState, active: true });
                }}
            >
                <AcademicArea subjects={subjects} />
            </CSSTransition>

            <CSSTransition
                in={cocurricularState.active}
                timeout={500}
                classNames="feriaCultural-subarea"
                unmountOnExit
                onEnter={() => {
                    setStudentProfileState({ enter: false, active: false });
                    setAcademicAreasState({ enter: false, active: false });
                    setAlliesState({ enter: false, active: false });
                    setToolsState({enter: false, active: false});
                }}
                onExited={() => {
                  if (academicAreasState.enter) setAcademicAreasState({ ...academicAreasState, active: true });
                  if (alliesState.enter) setAlliesState({ ...alliesState, active: true });
                  if (toolsState.enter) setToolsState({ ...toolsState, active: true });
                  if (studentProfileState.enter) setStudentProfileState({ ...studentProfileState, active: true });
                }}
            >
                <InterdisciplinaryActivities />
            </CSSTransition>

            <CSSTransition
                in={alliesState.active}
                timeout={500}
                classNames="feriaCultural-subarea"
                unmountOnExit
                onEnter={() => {
                    setStudentProfileState({ enter: false, active: false });
                    setAcademicAreasState({ enter: false, active: false });
                    setToolsState({enter: false, active: false});
                    setCocurricularState({enter: false, active: false});                    
                }}
                onExited={() => {
                  if (studentProfileState.enter) setStudentProfileState({ ...studentProfileState, active: true });
                  if (academicAreasState.enter) setAcademicAreasState({ ...academicAreasState, active: true });
                  if (toolsState.enter) setToolsState({ ...toolsState, active: true });
                  if (cocurricularState.enter) setCocurricularState({ ...cocurricularState, active: true });
                }}
            >
                <h1>Aliados y acreditaciones</h1>
            </CSSTransition>

            <CSSTransition
                in={toolsState.active}
                timeout={500}
                classNames="feriaCultural-subarea"
                unmountOnExit
                onEnter={() => {
                    setStudentProfileState({ enter: false, active: false });
                    setAcademicAreasState({ enter: false, active: false });
                    setAlliesState({enter: false, active: false});
                    setCocurricularState({enter: false, active: false});
                }}
                onExited={() => {
                  if (studentProfileState.enter) setStudentProfileState({ ...studentProfileState, active: true });
                  if (academicAreasState.enter) setAcademicAreasState({ ...academicAreasState, active: true });
                  if (alliesState.enter) setAlliesState({ ...alliesState, active: true });
                  if (cocurricularState.enter) setCocurricularState({ ...cocurricularState, active: true });
                }}
            >
               <EducativeModel/>
            </CSSTransition>

          {/* <CSSTransition
            in={blankState.active}
            timeout={500}
            classNames="optativas-subarea"
            unmountOnExit
            onEnter={() => {
              setAcademicAreasState({ enter: false, active: false });
              setStudentProfileState({ enter: false, active: false });
              setAlliesState({ enter: false, active: false });
              setToolsState({ enter: false, active: false });
              setCocurricularState({ enter: false, active: false });
            }}
            onExited={() => {
              if (academicAreasState.enter) setAcademicAreasState({ ...academicAreasState, active: true });
              if (studentProfileState.enter) setStudentProfileState({ ...studentProfileState, active: true });
              if (alliesState.enter) setAlliesState({ ...alliesState, active: true });
              if (toolsState.enter) setToolsState({ ...toolsState, active: true });
              if (cocurricularState.enter) setCocurricularState({ ...cocurricularState, active: true });
            }}
          >
          </CSSTransition> */}

            {/* <Dialog /> */}
        </div>
        <div className="subpage activies-container">
          <Links animationStates={animationStates} linkState={linkState} handleCurrentLinkState={handleCurrentLinkState} />
        </div>
      </div>
    </div>
  );
};

export default CurriculumPage;
